"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

var _flatMapInstanceProperty = require("@babel/runtime-corejs3/core-js/instance/flat-map");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.acquireToken = exports.AcquireTokenError = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createSuper"));

var _wrapNativeSuper2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/wrapNativeSuper"));

var _bindCallback = require("rxjs/observable/bindCallback");

var _of = require("rxjs/observable/of");

var _operators = require("rxjs/operators");

var _overrideSettings = require("../shared/override-settings/overrideSettings");

var _auth = require("./auth");

var AcquireTokenError = /*#__PURE__*/function (_Error) {
  (0, _inherits2.default)(AcquireTokenError, _Error);

  var _super = (0, _createSuper2.default)(AcquireTokenError);

  function AcquireTokenError(error, errorDescription) {
    var _this;

    (0, _classCallCheck2.default)(this, AcquireTokenError);
    _this = _super.call(this, error + ' ' + errorDescription);
    _this.error = void 0;
    _this.errorDescription = void 0;
    _this.error = error;
    _this.errorDescription = errorDescription;
    return _this;
  }

  return AcquireTokenError;
}( /*#__PURE__*/(0, _wrapNativeSuper2.default)(Error));

exports.AcquireTokenError = AcquireTokenError;
var boundAcquireToken = (0, _bindCallback.bindCallback)(function (audience, callback) {
  var auth = (0, _auth.getCustomAuthProvider)();
  var telemetryEmitter = (0, _overrideSettings.getOverrideSetting)('telemetryImplementation');
  auth.acquireToken(audience).then(function (token) {
    return callback({
      token: token
    });
  }).catch(function (e) {
    callback({
      token: null,
      error: e
    });
    telemetryEmitter === null || telemetryEmitter === void 0 ? void 0 : telemetryEmitter.error('auth/acquireToken', {
      error: "Failed to acquire token:".concat(e)
    });
  });
});
/**
 * Gets an observable which resolve to an auth token if successful.
 * @param audience The resource/audience to acquire a token for or the login resource if not specified
 */

var acquireToken = function acquireToken(audience) {
  var _getOverrideSetting;

  if (process.env.APP_FEATURE_SECURITY_ENABLE_IFRAME !== 'true' && window !== top) {
    throw new AcquireTokenError('Invalid window', 'Acquire token must be called from top window.');
  }

  var onAcquireTokenResult = function onAcquireTokenResult(result) {
    var error = result.error,
        token = result.token;

    if (token != null && token.length > 0) {
      return (0, _of.of)(token);
    }

    throw new AcquireTokenError(error || 'failed to acquire token');
  };

  var clientId = (_getOverrideSetting = (0, _overrideSettings.getOverrideSetting)('clientId')) !== null && _getOverrideSetting !== void 0 ? _getOverrideSetting : (0, _auth.getCustomAuthProvider)().clientId;
  return boundAcquireToken(audience !== undefined ? audience : clientId).pipe((0, _flatMapInstanceProperty(_operators))(onAcquireTokenResult));
};

exports.acquireToken = acquireToken;